//stripe
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import api from "./api";
import LoadingIcon from "../components/LoadingIcon";
import { toast } from "react-toastify";

const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY
);

export default function StripeWrapper({ children, plan, authToken }) {
  const [clientSecret, setClientSecret] = useState("");
  const [dpmCheckerLink, setDpmCheckerLink] = useState("");


  const options = {
    clientSecret: clientSecret,
    loader: "auto",
    locale: "pt",
    appearance: {
      theme: "flat",
      variables: {
        colorPrimary: "#35b8a6",
        colorBackground: "#fafafa",
        colorText: "#222",
        colorDanger: "#df1b41",
        fontFamily: "Inter, sans-serif",
        fontSizeBase: "14px",
        borderRadius: "12px",
        spacingUnit: "6px",
      },
      rules: {
        ".Input": {
          borderRadius: "12px",
          padding: "12px",
          backgroundColor: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "300",
          color: "#BFB7B8",
        },
        ".Input:focus": {
          borderColor: "#35b8a6",
          boxShadow: "0 0 0 2px rgba(53, 184, 166, 0.2)",
        },
        ".Label": {
          color: "#091023",
          fontWeight: "300",
          fontSize: "14px",
          marginBottom: "4px",
        },
        ".Tab": {
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "10px",
        },
        ".Tab:hover": {
          backgroundColor: "#f7f7f7",
        },
      },
    },
  };

  const getIntent = async () => {
    try {
      const { data } = await api.post(
        "/companies/subscriptions/payment_intents",
        {
          data: {
            attributes: {
              payment_plan_id: plan,
            },
          },
        },
        authToken && {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (data?.clientSecret) {
        setClientSecret(data.clientSecret);
      }
    } catch (error) {
      toast.error("Erro ao obter a intenção de pagamento:", error);
    }
  };

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    getIntent();
  }, []);

  return (
    <>
      {clientSecret ? (
        <Elements
          options={options}
          stripe={stripePromise}
        >
          {children}
        </Elements>
      ) : (
        <div className="containerPlans" style={{ alignItems: "center" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "150px",
              width: "250px",
            }}
          >
            <LoadingIcon />
          </div>
        </div>
      )}
    </>
  );
}
